import type {ApiQueryParams} from '@/types/api';
import type {ImageDepth, ImageType} from 'shared';

export const projectKeys = {
  all: ['projects'] as const,

  lists: () => [...projectKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams = {}) =>
    [...projectKeys.lists(), filters] as const,

  details: () => [...projectKeys.all, 'detail'] as const,
  detail: (id: string) => [...projectKeys.details(), id] as const,
};

export const imageKeys = {
  all: ['images'] as const,

  lists: () => [...imageKeys.all, 'list'] as const,
  list: (
    filters: ApiQueryParams<{
      type: ImageType;
      depth: ImageDepth;
      projectId: string;
    }> = {}
  ) => [...imageKeys.lists(), filters] as const,

  details: () => [...imageKeys.all, 'detail'] as const,
  detail: (id: string) => [...imageKeys.all, 'detail', id] as const,
};

export const captureDataKeys = {
  all: ['captureData'],

  details: () => [...captureDataKeys.all, 'detail'] as const,
  detail: (projectId: string) =>
    [...captureDataKeys.all, 'detail', projectId] as const,
};

export const annotationKeys = {
  all: ['annotations'] as const,

  // static key for a specific list of annotation stats
  stats: (projectId: string) =>
    [...annotationKeys.all, 'stats', projectId] as const,
};

export const imagesetKeys = {
  all: ['imagesets'] as const,

  lists: () => [...imagesetKeys.all, 'list'] as const,
  list: (projectId: string) => [...imagesetKeys.lists(), projectId] as const,
};

export const reportKeys = {
  all: ['reports'] as const,

  lists: () => [...reportKeys.all, 'list'] as const,
  list: (filters: ApiQueryParams<{projectId: string}>) =>
    [...reportKeys.lists(), filters] as const,
};
